import { SETTING_DOCS_VOCABULARIES } from './settings-docs/index.js';
/** D775: the words of Configurações › Regras governadas (rule names, descriptions, form fields). */
export const SLICE_D775 = [...SETTING_DOCS_VOCABULARIES];
//# sourceMappingURL=slice-d775.js.map